// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-check[data-v-4e376f5c] {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n}\n.form-check-input[data-v-4e376f5c] {\n  width: 1.6em;\n  height: 1.6em;\n}\n.form-check label[data-v-4e376f5c] {\n  //font-size: 1.6em;\n}\n.warning[data-v-4e376f5c] {\n  color: #e5bf00;\n}\n.danger[data-v-4e376f5c] {\n  color: #ff4848;\n}\n\n", ""]);
// Exports
module.exports = exports;
